import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Import your modals and hooks
import useAuth from '../../../hooks/useAuth';
import SubscriptionModal from "./SubModal"; 
import UpgradeModal from "./upgradeModal";

const PRICING_URL = "https://candidatetools-app-qa.web.app/pricing";

// This component no longer needs to check for verification.
export default function RouteGuard({ children, requireTiers = null, signOut }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
  
  // Get user properties
  const status = user?.subscriptionStatus;
  const tier = user?.subscriptionTier;

  // Define conditions
  const needsPlan = status !== "active";
  const wrongTier = requireTiers && !requireTiers.includes(tier);

  /* Button handlers */
  const handlePricing = () => window.location.replace(PRICING_URL);
  const handleRetry = () => window.location.reload();
  const handleDismiss = () => signOut();
  const handleUpgradeModalClose = () => { setUpgradeModalOpen(false); navigate('/'); }

  /* --- Logic Flow for Tiers and Status --- */

  // 1. Check for an active plan.
  if (needsPlan) {
    return (
      <SubscriptionModal
        open={true}
        onRetry={handleRetry}
        onPricing={handlePricing}
        onClose={handleDismiss}
      />
    );
  }

  // 2. Check for the required tier.
  if (wrongTier) {
    return (
      <>
        <UpgradeModal 
          open={true} 
          onClose={handleUpgradeModalClose}
          onPricing={handlePricing}
          requiredTier={requireTiers?.[0]} 
        />
        {children}
      </>
    );
  } 
  
  else {
    return children;
  }
}
